import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    convertUniversalDateTimeToPersianDateTime,
    convertUniversalDateToPersianDate,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCardInfoTypeOne,
    RaikoCardInfoTypeOneGridTypeItems,
    RaikoCardInfoTypeOneItemGenerator,
    RaikoCardInfoTypeOneStatusTypes,
    RaikoChipSizeType,
    RaikoChipTypes, RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoCustomSimpleActiveDeActiveChip,
    RaikoCustomSimpleChip,
    RaikoCustomTable,
    RaikoGridOneColumn,
    RaikoGridTwoColumn, RaikoTableSearchContainer,
    RaikoTableTitleContainer,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {WorkAndBusinessService} from "../../serverService/workAndBusinessService/WorkAndBusinessService";
import {useNavigate, useParams} from "react-router-dom";
import {LanguageHelper} from "../../util/LanguageHelper";
import {useDebounce} from "@uidotdev/usehooks";

export default function WorkAndBusiness({campaignId}) {

    let page = 0
    const size = 15


    const navigate = useNavigate()

    const [selectDisplayType, setSelectDisplayType] = useState(false);
    const [totalItems, setTotalItems] = useState(0);
    const [workAndBusinessData, setWorkAndBusinessData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [languageCode, setLanguageCode] = useState(LanguageHelper.getLanguageCode())

    const [titleFilter, setTitleFilter] = useState("")
    const [statusFilter, setStatusFilter] = useState("all")

    const _titleFilter = useDebounce(titleFilter, 500);
    const _statusFilter = useDebounce(statusFilter, 500);

    const service = new WorkAndBusinessService()

    useEffect(() => {
        if (typeof service != "undefined") {
            getDataFromServer()
        }
    }, [_titleFilter, _statusFilter]);


    function getDataFromServer() {
        setLoading(true)
        service.getAllBusinessList(
            campaignId,
            page,
            size,
            languageCode,
            _titleFilter,
            _statusFilter
        ).then((response) => {
            setTotalItems(response.numberOfItems)
            setPageCount(response.totalPage)

            setWorkAndBusinessData([])
            response.data.map((item, index) => {
                setWorkAndBusinessData(prev => [
                    ...prev,
                    prepareItem(
                        (page * size) + index + 1,
                        item.id,
                        item.metaData ? item.metaData.title : "-",
                        item.metaData && item.metaData.address ? item.metaData.address.slice(0, 20) + " ..." : "-",
                        item.metaData && item.metaData.hours && item.metaData.hours.length > 0 ? item.metaData.hours : "-",
                        item.createdAt,
                        item.createdBy,
                        item.phoneNumber ? item.phoneNumber : "-",
                        item.published,
                        item.status
                    )
                ])
            })

        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(() => {
            setLoading(false)
        })
    }

    function prepareItem(number, id, title, address, hours, createdAt, createdBy, phoneNumber, published, status) {
        return {
            number,
            id,
            title,
            address,
            hours,
            createdAt: convertUniversalDateTimeToPersianDateTime(createdAt),
            createdBy,
            phoneNumber,
            published: <RaikoCustomSimpleActiveDeActiveChip
                state={published}
                activeStateTitle={"منتشر شده"}
                deActiveStateTitle={"پیش نویس"}
            />,
            status,
            status_title: status === "AWAITING_FOR_REVIEW" ?
                <RaikoCustomSimpleChip
                    title={"درحال بررسی"}
                    type={RaikoChipTypes.warning}
                    size={RaikoChipSizeType.small}
                />
                : status === "ACCEPTED" ?
                    <RaikoCustomSimpleChip
                        title={"پذیرفته شده"}
                        type={RaikoChipTypes.success}
                        size={RaikoChipSizeType.small}
                    /> : <RaikoCustomSimpleChip
                        title={"رد شده"}
                        type={RaikoChipTypes.error}
                        size={RaikoChipSizeType.small}
                    />
            ,
        }
    }

    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }


    function handleShowDetail(placeId) {
        let _title = ""
        workAndBusinessData.map((item) => {
            if (item.id === placeId)
                _title = item.title
        })

        navigate(
            RouteHelper.TourismPlaceDetail.globalUrl.replace(":id", placeId),
            {state: {title: _title}, replace: false}
        )
    }

    return (
        <>
            <Helmet><title>{RouteHelper.WorkAndBusiness.name}</title></Helmet>
            <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={RouteHelper.WorkAndBusiness.name}
                            amount={totalItems}
                            hasSelectDisplayType
                            selectDisplayType={selectDisplayType}
                            setSelectDisplayType={setSelectDisplayType}
                        />

                        <RaikoTableSearchContainer
                            value={titleFilter}
                            setValue={setTitleFilter}
                            labelText={"عنوان"}
                            hasFilter
                            filterStatus={statusFilter && statusFilter !== "all"}
                            handleDeleteAllFilters={_ => {
                                setStatusFilter("")
                            }}
                        >
                            <RaikoCustomSelect
                                labelText={"وضعیت انتشار"}
                                value={statusFilter}
                                setValue={setStatusFilter}
                                items={[
                                    raikoCustomSelectItemGenerator("all", "همه"),
                                    raikoCustomSelectItemGenerator("true", "منتشر شده"),
                                    raikoCustomSelectItemGenerator("false", "پیش نویس"),
                                ]}

                            />
                        </RaikoTableSearchContainer>

                        <RaikoCustomTable
                            header={challengeTableHeader}
                            data={workAndBusinessData}
                            isLoading={loading}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePagination}
                            selectDisplayType={selectDisplayType}
                            rowClicked={handleShowDetail}
                        >
                            <RaikoGridTwoColumn className={css`padding: 3px;`}>
                                {
                                    workAndBusinessData.map((item, index) => {
                                        return <RaikoCardInfoTypeOne
                                            key={index}
                                            iconClass={"ic-camp"}
                                            title={item.title}
                                            titleLabel={item.address}
                                            status
                                            statusType={item.status === "AWAITING_FOR_REVIEW" ?
                                                RaikoCardInfoTypeOneStatusTypes.WARNING
                                                : item.status === "ACCEPTED" ?
                                                    RaikoCardInfoTypeOneStatusTypes.SUCCESS
                                                    : RaikoCardInfoTypeOneStatusTypes.ERROR
                                            }
                                            statusText={item.status === "AWAITING_FOR_REVIEW" ?
                                                "در حال بررسی"
                                                : item.status === "ACCEPTED" ?
                                                    "پذیرفته شده"
                                                    : "رد شده"}
                                            items={[
                                                RaikoCardInfoTypeOneItemGenerator("شماره تماس", item.phoneNumber),
                                                RaikoCardInfoTypeOneItemGenerator("ساعت کاری", item.hours),
                                                RaikoCardInfoTypeOneItemGenerator("تاریخ ساخت", item.createdAt ? item.createdAt : "-"),
                                                RaikoCardInfoTypeOneItemGenerator("سازنده", item.createdBy ? item.createdBy : "-"),
                                            ]}
                                            gridTypeItems={RaikoCardInfoTypeOneGridTypeItems.TWO_COLUMN}
                                            onClick={_ => {
                                                handleShowDetail(item.id)
                                            }}
                                        />
                                    })
                                }

                            </RaikoGridTwoColumn>
                        </RaikoCustomTable>
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>
        </>
    )
}


const challengeTableHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "title",
        label: "عنوان کسب و کار",
    },
    {
        id: "phoneNumber",
        label: "شماره همراه",
    },
    {
        id: "createdBy",
        label: "سازنده",
    },
    {
        id: "createdAt",
        label: "تاریخ ساخت",
    },
    {
        id: "published",
        label: "انتشار",
    },
    {
        id: "status_title",
        label: "وضعیت",
    },

]